<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->
    <main>
      <!--  =========== Start:: Filter Form =========== -->
      <div
        class="filter_content_wrapper"
        :class="{ active: filterFormIsActive }"
      >
        <button
          class="filter_toggler"
          @click="filterFormIsActive = !filterFormIsActive"
        >
          <i class="fal fa-times"></i>
        </button>
        <div class="filter_title_wrapper">
          <h5>{{ $t("TITLES.searchBy") }}</h5>
        </div>

        <div class="filter_form_wrapper">
          <form @submit.prevent="submitFilterForm">
            <div class="row justify-content-center align-items-center w-100">
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.store')"
                v-model.trim="filterOptions.store"
              />
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.package_name')"
                v-model.trim="filterOptions.name"
              />
            </div>

            <div class="btns_wrapper">
              <button class="submit_btn" :disabled="isWaitingRequest">
                <i class="fal fa-search"></i>
              </button>
              <button
                class="reset_btn"
                type="button"
                :disabled="isWaitingRequest"
                @click="resetFilter"
              >
                <i class="fal fa-redo"></i>
              </button>
            </div>
          </form>
        </div>
      </div>

      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>{{ $t("PLACEHOLDERS.Subscriptions") }}</h5>
        </div>
      </div>

      <v-data-table
        class="thumb"
        :loading="loading"
        :loading-text="$t('TABLES.loadingData')"
        :search="searchValue"
        :headers="tableHeaders"
        :items="tableRows"
        item-class="ltr"
        :items-per-page="paginations.items_per_page"
        hide-default-footer
      >
        <template v-slot:no-data>
          {{ $t("TABLES.noData") }}
        </template>

        <template v-slot:[`item.id`]="{ item, index }">
          <p class="blue-grey--text text--darken-1 fs-3" v-if="!item.id">-</p>
          <p v-else>
            {{
              (paginations.current_page - 1) * paginations.items_per_page +
              index +
              1
            }}
          </p>
        </template>

        <template v-slot:[`item.category`]="{ item }">
          <p class="blue-grey--text text--darken-1 fs-3" v-if="!item.category">
            -
          </p>
          <p v-else>
            {{ item.category.name }}
          </p>
        </template>

        <template v-slot:[`item.icon`]="{ item }">
          <p class="blue-grey--text text--darken-1 fs-3" v-if="!item.icon">-</p>
          <p v-else>
            <img :src="item.icon" class="icon-img" :alt="item.name" />
          </p>
        </template>
      </v-data-table>
    </main>

    <!-- Pagination -->
    <div class="pagination_container text-center mt-3 mb-0">
      <v-pagination
        class="py-0"
        square
        v-model="paginations.current_page"
        :length="paginations.last_page"
        :total-visible="6"
        @input="updateRouterQueryParam($event)"
        :prev-icon="
          getAppLocale === 'ar' ? 'fal fa-angle-right' : 'fal fa-angle-left'
        "
        :next-icon="
          getAppLocale === 'ar' ? 'fal fa-angle-left' : 'fal fa-angle-right'
        "
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Allsubscriptionss",

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  data() {
    return {
      loading: false,
      isWaitingRequest: false,

      filterFormIsActive: false,
      filterOptions: {
        name: null,
        store: null,
      },

      searchValue: "",
      tableHeaders: [
        {
          text: this.$t("TABLES.Admins.serialNumber"),
          value: "id",
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.store"),
          value: "store_name",
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.package_name"),
          value: "package_name",
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.PACKAGE_VALUE"),
          value: "price",
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.category"),
          value: "category",
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.start_date"),
          value: "start_date",
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.end_date"),
          value: "end_date",
          align: "center",
        },
      ],
      tableRows: [],

      dialogImage: false,
      selectedItemImage: null,
      dialogDescription: false,
      selectedDescriptionTextToShow: "",
      dialogDelete: false,
      itemToDelete: null,
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 6,
      },
    };
  },

  watch: {
    "$route.query.page": function () {
      this.paginations.current_page = +this.$route.query.page;
      this.setTableRows();
    },
  },

  methods: {
    async submitFilterForm() {
      if (this.$route.query.page !== "1") {
        await this.$router.push({
          path: "/subscriptions/all",
          query: { page: 1 },
        });
      }
      this.setTableRows();
    },

    async resetFilter() {
      this.filterOptions.name = null;
      this.filterOptions.store = null;
      if (this.$route.query.page !== "1") {
        await this.$router.push({
          path: "/subscriptions/all",
          query: { page: 1 },
        });
      }
      this.setTableRows();
    },
    updateRouterQueryParam(pagenationValue) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagenationValue,
        },
      });
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },

    async setTableRows() {
      this.loading = true;
      try {
        const res = await this.$axios({
          method: "GET",
          url: "subscriptions",
          params: {
            page: this.paginations.current_page,
            name: this.filterOptions.name,
            store: this.filterOptions.store,
          },
        });
        this.loading = false;
        this.tableRows = res.data.data.data;
        this.paginations.last_page = res.data.data.meta.last_page;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },

    editItem(item) {
      this.$router.push({ path: `/subscriptions/edit/${item.id}` });
    },

    selectDeleteItem(item) {
      this.dialogDelete = true;
      this.itemToDelete = item;
    },
    async confirmDeleteItem() {
      try {
        await this.$axios({
          method: "DELETE",
          url: `subscriptionss/${this.itemToDelete.id}`,
        });
        this.dialogDelete = false;
        this.setTableRows();
        this.$message.success(this.$t("MESSAGES.deletedSuccessfully"));
      } catch (error) {
        this.dialogDelete = false;
        this.$message.error(error.response.data.message);
      }
    },
  },

  created() {
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setTableRows();
  },
};
</script>

<style scoped>
.icon-img {
  width: 100px;
  margin: 4px;
}
</style>
